import { SimpleSelect } from '@aloft/toolkit-sui';

import { UseFormRegister } from 'react-hook-form';

import { ObjectiveCharacteristicsFormInput } from '../schObjectiveCharacteristics.ts';

export function FireplaceTypeSelect({
  register,
}: {
  register: UseFormRegister<ObjectiveCharacteristicsFormInput>;
}) {
  return (
    <SimpleSelect size="sm" {...register('fireplace.type')} required label="Fireplace">
      <option value="freestanding">Freestanding</option>
      <option value="zeroClearance">Zero Clearance</option>
      <option value="masonry">Masonry</option>
    </SimpleSelect>
  );
}
